// extracted by mini-css-extract-plugin
export default {"mainGrid":"IQxgbZxySRoD188VLxOt","pricingTable":"g2ZX5h62dqwMaKwoAzA8"};